module.exports = __webpack_public_path__ + "img/Group 454.0c038682.png";